import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../context';
import type { AccessGroup, AccessGroupMember } from '../types';

export function useAccessGroups(familyId: string | undefined) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['accessGroups', familyId],
    queryFn: () => apiClient.get<{ accessGroups: AccessGroup[] }>(`/api/families/${familyId}/access-groups`),
    enabled: !!familyId,
  });
}

export function useAccessGroupMembers(familyId: string | undefined, groupId: string | undefined) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['accessGroupMembers', familyId, groupId],
    queryFn: () => apiClient.get<{ members: AccessGroupMember[] }>(`/api/families/${familyId}/access-groups/${groupId}/members`),
    enabled: !!familyId && !!groupId,
  });
}

export function useSetAccessGroupMembers(familyId: string | undefined, groupId: string | undefined) {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userIds: string[]) =>
      apiClient.put(`/api/families/${familyId}/access-groups/${groupId}/members`, { userIds }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['accessGroups', familyId] });
      queryClient.invalidateQueries({ queryKey: ['accessGroupMembers', familyId, groupId] });
    },
  });
}
